<template>
  <div class="categories">
    <h1 class="page-title">Categories</h1>

    <div class="page-content -column -column-one -form">
      <category-form :category="newCategory" :state="formState" @submitted="createCategory"></category-form>
    </div>

    <div class="page-content -column -column-two">
      <category-list :categories="organisedCategories" @categoryClicked="categoryClick"></category-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import categoryForm from "@/components/categoryForm";
import categoryList from "@/components/categoryList";
import auth from "@/helpers/auth";

export default {

  components: { categoryForm, categoryList },
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  data() {
    return {
      formState: "normal",
      newCategory: {
        label: "",
        weighting: 1,
        keywords: "",
        negative_keywords: "",
        parent_id: "",
        query_id: "",
        fallback: false,
        max_consecutive: null
      }
    };
  },

  computed: {
    ...mapGetters(["organisedCategories"])
  },

  methods: {
    createCategory(params) {
      if (this.formState !== "normal") return;
      this.formState = "loading";

      if (this.newCategory.label.length < 3) {
        console.error("Category name must be at least 3 letters long");
        this.formState = "normal";
        return;
      }

      this.$store
        .dispatch("createCategory", this.newCategory)
        .then((resp) => {
          this.newCategory = {
            label: "",
            weighting: 1,
            keywords: "",
            parent_id: "",
            query_id: "",
            fallback: false,
            max_consecutive: null
          };

          this.formState = "done";
          setTimeout(() => {
            this.formState = "ready";
          }, 1000);
        })
        .catch((err) => {
          console.error("Error creating category:", err);
          this.formState = "normal";
        });
    },

    categoryClick(category) {
      this.$router.push("/categories/" + category.id);
    }
  }
};
</script>
